<template>
    <TsCard :append-class="twMerge('h-full bg-idle-white', appendClass)" no-shadow :no-border="noBorder">
        <TsTypography append-class="text-black mb-4">
            {{ useTranslation('Events-clickToStayUpdated', 'Klik op Geïnteresseerd om op de hoogte te blijven van dit evenement') }}.
        </TsTypography>

        <TsMedia v-if="data?.interestedCount >= 0" append-class="items-center">
            <TsMediaContent>
                <TsMedia append-class="max-md:flex-col">
                    <TsMediaStart>
                        <div class="flex items-center">
                            <TsIcon class="text-success mr-2 cursor-pointer"
                                :name="isInterested ? 'mdi:thumbs-up' : 'line-md:thumbs-up'"
                                size="32"
                                @click="emit('interested')" />
                            <TsTypography as="span" variant="h2" append-class="mb-0 select-none">
                                {{ data?.interestedCount }}
                            </TsTypography>
                        </div>
                    </TsMediaStart>
                    <TsMediaContent>
                        <TsTypography size="xs" append-class="mb-0 mr-3">
                            {{ useTranslation('Events-peopleHaveShownInterest', 'Mensen hebben de laatste tijd interesse getoond') }}
                        </TsTypography>
                    </TsMediaContent>
                </TsMedia>
            </TsMediaContent>
            <TsMediaEnd>
                <TsButton
                    :append-class="`font-semibold text-base leading-[24px] px-5`"
                    size="xs" 
                    :outlined="!isInterested"
                    @click="emit('interested')">
                    {{ useTranslation('interested', 'Geïnteresseerd') }}?
                </TsButton>
            </TsMediaEnd>
        </TsMedia>
    </TsCard>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);
const TsMediaStart = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaStart.vue')
);
const TsMediaContent = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaContent.vue')
); 
const TsMediaEnd = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaEnd.vue')
);

const emit = defineEmits(["interested"]);

type Props = {
    data: object[];
    customer_id: string;
    appendClass?: string;
    noBorder?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
    data: () => [],
});

const isInterested = computed(() => props.data?.interestedCustomers?.includes(props.customer_id));
</script>